export const FURNITURE_TYPE_LABELS: Record<string, string> = {
  SOFA: 'Sofa',
  BED: 'Bed',
  CHAIR_ARMCHAIR: 'Chair / Armchair',
  TABLE: 'Table / Coffee Table',
  OTHER_WITH_FABRICS: 'Other with fabrics',
  OTHER: 'Other',
  LIGHTS: 'Lights',
}

export const FURNITURE_TYPES = [
  'SOFA', 'BED', 'CHAIR_ARMCHAIR', 'TABLE',
  'OTHER_WITH_FABRICS', 'OTHER', 'LIGHTS',
] as const
